import API from "../api/axios.config";

class SolutionService {
  
  getSolution(id) {
    return API.get(`/solution/${id}`);
  }

  getSolutionByProblem(id) {
    return API.get(`/solution/problem/${id}`);
  }

  addSolutionByProblem(pbid, description) {
    return API.post(`/solution/submit/${pbid}`, {description});
  }


}

export default new SolutionService();